import { api, otherApiClient } from ".";
/**
 * 상품의 자료 유형을 꺼낸다 — `product.source` 가 자료(HandoutDTO)일 때만 값이 있다.
 *
 * `/entitlements` 의 `productHandoutType` 과 구매모듈의 freepass 분기가 같은 값을 쓴다.
 */ export const getProductHandoutType = (product)=>{
    var _ref;
    return (_ref = product === null || product === void 0 ? void 0 : product.source) === null || _ref === void 0 ? void 0 : _ref.type;
};
export const SourceTypeWithString = {
    textbook: "교과서 라이선스",
    workbook: "참고서 라이선스",
    handout: "자료",
    work: "문학 라이선스",
    all: "전체",
    aladinbook: "도서",
    ebook: "굿노트6 eBook",
    package: "이용권",
    ebookUniv: "굿노트6 대학생용 eBook",
    pod: "제본",
    cash: "캐시 상품"
};
// EN : 영어, KO : 한국어, MA : 수학, SC : 과학, SO : 사회, SL : 제2외국어, KH : 한국사, ET : 기타
export const Subjects = {
    EN: "EN",
    KO: "KO",
    MA: "MA",
    SO: "SO",
    SC: "SC",
    SL: "SL",
    KH: "KH",
    HI: "HI",
    ET: "ET",
    ALL: "ALL"
};
export function isSubjects(value) {
    return !!Object.values(Subjects).find((v)=>v === value);
}
// 주요 과목 5개 (영어, 국어, 수학, 사회, 과학)
export const MAIN_SUBJECTS = [
    Subjects.EN,
    Subjects.KO,
    Subjects.MA,
    Subjects.SO,
    Subjects.SC
];
//구매가능한 과목 리스트 (검색, 과목탭에서 사용)
export const purchasableSubjectsList = ()=>{
    return [
        Subjects.EN,
        Subjects.KO,
        Subjects.MA,
        Subjects.SC,
        Subjects.SO
    ].map((subject)=>{
        return {
            key: subject,
            label: SubjectsWithString[subject]
        };
    });
};
export const DataTypesWithString = {
    10: "기출예상문제",
    20: "단계별복습",
    30: "변형문제",
    40: "본문분석",
    50: "워크북",
    60: "작품분석",
    70: "어법어휘",
    80: "예상문제",
    90: "모의고사",
    100: "개념완성",
    110: "유형훈련",
    120: "직보/파이널",
    130: "개념정리"
};
export const CurriculumsWithString = {
    10: "초등",
    20: "중등",
    30: "고등",
    40: "대학생",
    null: ""
};
export const GradesWithString = {
    // 10 : 1학년, 20 : 2학년, 30 : 3학년, 40 : 4학년, 50 : 5학년 , 60 : 6학년
    10: "1학년",
    20: "2학년",
    30: "3학년",
    40: "4학년",
    50: "5학년",
    60: "6학년",
    null: ""
};
export const SubjectsWithString = {
    EN: "영어",
    KO: "국어",
    MA: "수학",
    SO: "사회",
    SC: "과학",
    SL: "제2외국어",
    KH: "한국사",
    HI: "역사",
    ET: "기타",
    ALL: "전과목"
};
export const ContentTypesWithString = {
    11: "어휘 정리",
    12: "문법 정리",
    13: "표현 정리",
    14: "이해추론 정리",
    21: "어휘 훈련",
    22: "문법 훈련",
    23: "표현 훈련",
    24: "이해추론 훈련",
    31: "어휘 문제풀이",
    32: "문법 문제풀이",
    33: "표현 문제풀이",
    34: "이해추론 문제풀이"
};
export const getLegacyProduct = async (query)=>{
    const { data  } = await api.get("/products/".concat(query.id));
    return data;
};
export const getProduct = async (query, accessToken)=>{
    const { data  } = await otherApiClient.market.get("/products/".concat(query.id), {
        headers: accessToken ? {
            Authorization: accessToken
        } : undefined
    });
    return data;
};
export const postUseMembership = async (param)=>{
    var _param_choicePurchaseOption;
    const { data  } = await otherApiClient.market.post("/products/use-as-membership", {
        membershipIdToProductIds: {
            [param.membershipId]: param.productIds
        },
        choicePurchaseOption: (_param_choicePurchaseOption = param.choicePurchaseOption) !== null && _param_choicePurchaseOption !== void 0 ? _param_choicePurchaseOption : "view"
    });
    return data;
};
/**
 * 구독으로 상품 이용하기 — `POST /products/use-as-subscription`
 *
 * 이용권(`use-as-membership`)과 응답이 같아(`{ licenseIds }`) 성공 처리는 공유하지만,
 * 요청 형태가 다르다 — 멤버십 맵이 아니라 `subscriptionId` 단일 필드다.
 * 여러 구독을 섞어 보낼 수 없다(BE D10 — FEFO 락 순서 데드락 방지).
 *
 * 서버가 구독의 커버 이용권 중 조건을 만족하는 것을 골라 담기를 위임하며,
 * 그 판정은 `GET /entitlements` 의 `usable` 과 같은 코드를 탄다.
 */ export const postUseSubscription = async (param)=>{
    var _param_choicePurchaseOption;
    const { data  } = await otherApiClient.market.post("/products/use-as-subscription", {
        subscriptionId: param.subscriptionId,
        productIds: param.productIds,
        choicePurchaseOption: (_param_choicePurchaseOption = param.choicePurchaseOption) !== null && _param_choicePurchaseOption !== void 0 ? _param_choicePurchaseOption : "view"
    });
    return data;
};
export const getRelatedProducts = async (id)=>{
    const { data  } = await otherApiClient.market("/products/".concat(id, "/relation"));
    return data;
};
export const getMembershipAvailable = async (param)=>{
    let { membershipId , productIds  } = param;
    const { data  } = await otherApiClient.market.post("/products/membership-available", {
        membershipIdToProductIds: {
            [membershipId]: productIds
        }
    });
    return data;
};
/**
 * 구독으로 상품을 쓸 수 있는지 사전 판정 — `POST /products/subscription-available`
 *
 * `membership-available` 의 구독 대응. 요청·응답 모두 형태가 다르다.
 * - 요청: 멤버십 맵(`membershipIdToProductIds`)이 아니라 `subscriptionId` 단일 필드.
 *   구독 id 가 uuid 라 "키는 양의 정수 문자열" 제약의 멤버십 맵에 넣을 수 없다
 * - 응답: `subscriptionId` 가 `data[]` 항목이 아니라 최상위에 온다
 * - `choicePurchaseOption` 을 받는다 (이용권 쪽은 보내지 않고 있음 — plan.md §4.2 후속 과제)
 *
 * 판정 코드는 `GET /entitlements` 의 `usable` 과 같다.
 */ export const getSubscriptionAvailable = async (param)=>{
    let { subscriptionId , productIds , choicePurchaseOption  } = param;
    const { data  } = await otherApiClient.market.post("/products/subscription-available", {
        subscriptionId,
        productIds,
        choicePurchaseOption: choicePurchaseOption !== null && choicePurchaseOption !== void 0 ? choicePurchaseOption : "view"
    });
    return data;
};
/**
 * 여러 이용권에 대한 상품 사용 가능 여부 확인
 * @param membershipIds - 이용권 ID 배열
 * @param productId - 상품 ID
 */ export const getMembershipAvailableMultiple = async (membershipIds, productId)=>{
    const membershipIdToProductIds = {};
    membershipIds.forEach((id)=>{
        membershipIdToProductIds[id] = [
            productId
        ];
    });
    const { data  } = await otherApiClient.market.post("/products/membership-available", {
        membershipIdToProductIds
    });
    return data;
};
